var map = {
	"./hw_days_2041-2060_allpct.jpg": 444024,
	"./hw_days_2061-2080_allpct.jpg": 41528,
	"./hw_days_2081-2100_allpct.jpg": 669868,
	"./hw_events_2041-2060_allpct.jpg": 556696,
	"./hw_events_2061-2080_allpct.jpg": 239764,
	"./hw_events_2081-2100_allpct.jpg": 149192,
	"./hw_meanmag_2041-2060_allpct.jpg": 596948,
	"./hw_meanmag_2061-2080_allpct.jpg": 255548,
	"./hw_meanmag_2081-2100_allpct.jpg": 339588
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 140624;